import { render, staticRenderFns } from "./StocksList.vue?vue&type=template&id=07c98c1d&scoped=true"
import script from "./StocksList.vue?vue&type=script&lang=ts"
export * from "./StocksList.vue?vue&type=script&lang=ts"
import style0 from "./StocksList.vue?vue&type=style&index=0&id=07c98c1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c98c1d",
  null
  
)

export default component.exports